import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersBackToPdpBtnComponent extends BaseComponent2 {
    public readonly rootSelector = '.js_of_back-to-pdp-btn';

    public onReloadComponentEvent(): Promise<void> {
        return Promise.resolve(undefined);
    }
}
